import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { IPhaseModal } from 'types/phases.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { advanceRuleList, executableTypeList, horizonList } from '../../plansData'

export const PhasesModal = ({ closeModal, value }: { closeModal: () => void, value?: IPhaseModal }) => {
    const [state, setState] = useState<IPhaseModal>(value || {
        name: '',
        executableType: null,
        advanceRule: null,
        horizon: null,
    })
    useFocusFirstInput()
    useModalClose(closeModal)

    const invalid = !state.name || !state.executableType?.value || !state.advanceRule?.value || !state.horizon?.value

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState(prev => ({ ...prev, name: e.target.value }))
    }

    const handleSelect = (v: ISelectValue, n: string) => {
        setState(prev => ({ ...prev, [n]: v }))
    }

    const handleSave = () => {
        closeModal()
    }

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Phase</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Enter phase name...' labelText='Name' value={state.name} onChange={handleChange} nomarg />
                <HonestSelectInput
                    options={executableTypeList}
                    labelText='Executable type'
                    nomarg
                    name='executableType'
                    onChange={handleSelect}
                    defaultValue={state.executableType?.value}
                    invalid={!state.executableType}
                />
                <HonestSelectInput
                    options={advanceRuleList}
                    labelText='Advance rule'
                    nomarg
                    name='advanceRule'
                    onChange={handleSelect}
                    defaultValue={state.advanceRule?.value}
                    invalid={!state.advanceRule}
                />
                <HonestSelectInput
                    options={horizonList}
                    labelText='Horizon'
                    nomarg
                    name='horizon'
                    onChange={handleSelect}
                    defaultValue={state.horizon?.value}
                    invalid={!state.horizon}
                />
            </Flex>
            <Button mt='16' disabled={invalid} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}
